<button class="action" (click)="toggleActiveTree($event, tree)" id="{{componentId}}"
        [ngClass]="{'mobile': navigationService.useMobileNav$  | async, 'active':isTreeActive(tree), 'activeChildren':activeChildren}">
    <div class="action-media" [class.mobile]="navigationService.useMobileNav$ | async">
        <fui-icon class="action-media-object" [height]="tree.icon.height" [icon]="tree.icon.icon"
                  id="icon" [width]="tree.icon.width"></fui-icon>
    </div>
    <div class="action-label" [class.mobile]="navigationService.useMobileNav$ | async">
        <div class="action-label-title" [class.mobile]="navigationService.useMobileNav$ | async" id="title">
            {{ tree.title | translate }}
        </div>
    </div>
</button>
<div class="modal" [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'active': isTreeActive(tree)}"
     [routerLinkActive]="'active'">
    @if (isTreeActive(tree)) {
        @if (!(navigationService.useMobileNav$ | async)) {
            <div class="modal-header">
                <fui-navigation-search id="search"></fui-navigation-search>
            </div>
        }
        <div class="modal-main" [class.mobile]="navigationService.useMobileNav$ | async">
            <fui-navigation-branches [branches]="tree.branches" id="branches"></fui-navigation-branches>
        </div>
    }
</div>
